// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"477":"fe6ea47d","654":"32b05f58","933":"e27a8475","994":"fab93290","995":"944b51b7"}[chunkId] + ".chunk.css";
};